import script from "./aiorder_edit.vue?vue&type=script&setup=true&lang=js"
export * from "./aiorder_edit.vue?vue&type=script&setup=true&lang=js"

import "./aiorder_edit.vue?vue&type=style&index=0&id=248db874&lang=css"

const __exports__ = script;

export default __exports__